import React from 'react';

import { QButton, QDivider, QEmptyState, QFlex, QHeading, QIcon, QSpacer, QStack, QText } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

type ConfigurationTemplateProps = {
  template: any;
  name: string;
  handleUseTemplate: () => void;
  handleCreateFromScratch: () => void;
};

export const ConfigurationTemplate: React.FC<ConfigurationTemplateProps> = ({
  template,
  name,
  handleUseTemplate,
  handleCreateFromScratch,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <QEmptyState
        title={t('policyConfiguration.template.title')}
        subtitle={t('policyConfiguration.template.subtitle')}
      />
      <QStack direction="column" alignItems="center" spacing={4} pb={4}>
        <QText>{t('policyConfiguration.template.useTemplate', { name: name.toLowerCase() })}</QText>
        <QFlex>
          <QSpacer />
          <QStack
            spacing={6}
            bg="blue.50"
            p={4}
            border="1px"
            borderColor="blue.400"
            borderRadius="base"
            maxWidth="640px"
          >
            {template.map((item: any, index: number) => (
              <QFlex key={index} direction="column">
                <QFlex align="center">
                  <QIcon iconName="CheckCircle" color="blue.500" />
                  <QHeading ml={2} fontSize="xs" fontWeight="semibold">
                    {item.title}
                  </QHeading>
                </QFlex>
                <QText color="gray.500" fontSize="xs">
                  {item.description}
                </QText>
              </QFlex>
            ))}
          </QStack>
          <QSpacer />
        </QFlex>
        <QButton onClick={handleUseTemplate}>{t('policyConfiguration.template.buttons.useTemplate')}</QButton>
        <QFlex direction="row">
          <QDivider />
          {t('policyConfiguration.template.divider')}
          <QDivider />
        </QFlex>
        <QButton variant="outline" onClick={handleCreateFromScratch}>
          {t('policyConfiguration.template.buttons.createFromScratch')}
        </QButton>
      </QStack>
    </>
  );
};
